import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MenuVisibilityService } from '../left-menu/menu-visibility.service';
import { NotificationsService } from '../stokker/api';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  /** olvasatlan értesítések — a harang jelvénye a mobil fejlécben */
  notifUnread = 0;
  private sub?: Subscription;

  constructor(public navigationService: MenuVisibilityService, private notifications: NotificationsService) {}

  ngOnInit(): void {
    this.sub = this.notifications.unread$.subscribe((count) => (this.notifUnread = count));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
